import api from "./api";

export const getWhatsNewUnreadCount = async () => {
  const response = await api.get("/api/v1/whats-new/unread-count");
  return Number(response?.data?.data?.count || 0);
};

export const getWhatsNewItems = async ({
  limit = 5,
  onlyUnread = false,
} = {}) => {
  const response = await api.get("/api/v1/whats-new", {
    params: {
      limit,
      onlyUnread,
    },
  });

  return response?.data?.data?.items || [];
};

export const markWhatsNewAsRead = async (id) => {
  const response = await api.post(`/api/v1/whats-new/${id}/read`);
  return response?.data;
};

export const markAllWhatsNewAsRead = async () => {
  const response = await api.post("/api/v1/whats-new/mark-all-read");
  return response?.data;
};
